import { Flex, Text } from '@chakra-ui/react';
import { faBell } from '@fortawesome/pro-regular-svg-icons';
import { Accordion } from '@morressier/alembic';

import { IconBadge } from 'src/components/IconBadge';

import AdditionalInformationWrapper from '../AdditionalInformationWrapper';
import { ReviewDetailsTab } from '../../../../pages/Review';

import { ReviewScoreHighlight } from './ReviewScoreHighlight';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import { getPhaseContent } from 'src/utils/phaseCopy';
import dateFormat from 'dateformat';
import { IWorkPhase } from '@publishing-engine/domain/models';

export const ReviewerRevisionAdditionalInfo = ({
  setActiveTab
}: {
  setActiveTab?: (tab: ReviewDetailsTab) => void;
}) => {
  const { review, workflowResponse } = useReviewData();
  const submittedAt =
    review.caseData.revisionAssessment?.date ||
    review.caseData.firstAssessment?.date;
  const revisionPhaseCopy = getPhaseContent(
    (workflowResponse.workflowData.currentState as IWorkPhase) || 'revision',
    'reviewer',
    {
      dateSent: submittedAt
        ? dateFormat(new Date(submittedAt), 'mmm d, yyyy')
        : undefined
    }
  );
  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and assessment information for this
                    revision phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <Text>{revisionPhaseCopy.description}</Text>
                <ReviewScoreHighlight setActiveTab={setActiveTab} />
              </Flex>
            )
          }
        ]}
      />
    </AdditionalInformationWrapper>
  );
};
